/**
 * State auth-флоу: регистрация, логин, password-reset.
 */

export const state = {
    // Registration progress (step1 userType → step2 formData → step3 SMS code)
    registration: {
        userType: null, // 'regular' | 'designer'
        formData: {},
    },
    resendTimerId: null,
};

export const PERSON_TITLES = ['Mr.', 'Mrs.', 'Ms.'];
